



import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const initialFieldValues = {
    serviceTypeId: '00000000-0000-0000-0000-000000000000',
    salonId: '',
    name: '',
    durationMinutes: 30,
    price: 0,
    category: '',
    isActive: true
};

const SalonService = () => {
    const [lists, setLists] = useState([]);
    const [categories, setCategories] = useState([]); 
    const [btnLoading, setBtnLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [values, setValues] = useState(initialFieldValues);

    const THEME_COLOR = '#065f46';
    const loggedInSalonId = localStorage.getItem('salonId');
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        if (loggedInSalonId) {
            GetData();
            GetCategories();
            setValues(prevValues => ({ ...prevValues, salonId: loggedInSalonId }));
        }
    }, []);

    const GetData = async () => {
        try {
            if (!loggedInSalonId) return;
            const res = await axios.get(`${config.APIACTIVEURL}${config.GetServiceTypesBySalonId}/${loggedInSalonId}`);
            if (res.data && res.data.data) setLists(res.data.data);
        } catch (error) { console.error("Error fetching services:", error); }
    };

    const GetCategories = async () => {
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES);
            setCategories(res.data || []);
        } catch (error) { console.error("Error fetching categories:", error); }
    };

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setValues({ ...values, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!loggedInSalonId) return;
        setBtnLoading(true);
        try {
            const isNew = values.serviceTypeId === "00000000-0000-0000-0000-000000000000";
            const serviceData = { ...values, salonId: loggedInSalonId };
            if (isNew) {
                await axios.post(config.APIACTIVEURL + config.CREATESERVICETYPE, serviceData);
            } else {
                await axios.put(config.APIACTIVEURL + config.UPDATESERVICETYPE, serviceData);
            }
            setShowModal(false);
            GetData();
        } catch (error) { alert(error.response?.data?.message || "Error saving service"); }
        finally { setBtnLoading(false); }
    };

    const handleDelete = async () => {
        try {
            await axios.delete(config.APIACTIVEURL + config.DELETESERVICETYPE + "/" + itemToDelete);
            setShowDeleteModal(false);
            GetData();
        } catch (error) { console.error("Error deleting service:", error); }
    };

    const resetForm = () => {
        setValues({ ...initialFieldValues, salonId: loggedInSalonId });
    };
    
    const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

    return (
        <div className="page-content" style={{ paddingTop: "80px" }}>
            <div className="container-fluid py-3 py-md-4">
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-header bg-white border-0 py-3 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3">
                        <h4 className="fw-bold mb-0" style={{ color: '#064e3b' }}>Service Management</h4>
                        <button className="btn text-white fw-bold px-4 shadow-sm"
                            style={{ backgroundColor: THEME_COLOR }}
                            onClick={() => { resetForm(); setShowModal(true); }}
                            disabled={!loggedInSalonId}>
                            <i className="ri-add-line me-1"></i> Add Service
                        </button>
                    </div>

                    <div className="card-body p-0 p-md-3">
                        {/* DESKTOP TABLE */}
                        <div className="table-responsive d-none d-md-block">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr className="text-secondary small text-uppercase text-center">
                                        <th className="text-start ps-4">Service Name</th>
                                        <th>Category</th>
                                        <th>Duration</th>
                                        <th>Price</th>
                                        <th>Status</th>
                                        <th className="pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lists.length === 0 ? (
                                        <tr><td colSpan="6" className="text-center py-4 text-muted">No services found.</td></tr>
                                    ) : (
                                        lists.map((item) => (
                                            <tr key={item.serviceTypeId} className="text-center">
                                                <td className="fw-bold text-dark text-start ps-4">{item.name}</td>
                                                <td><span className="badge bg-light text-dark border px-3">{item.category || 'Uncategorized'}</span></td>
                                                <td>{item.durationMinutes} min</td>
                                                <td className="fw-bold text-success">{formatCurrency(parseFloat(item.price))}</td>
                                                <td>
                                                    <span className={`badge rounded-pill ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                                        {item.isActive ? 'Active' : 'Inactive'}
                                                    </span>
                                                </td>
                                                <td className="pe-4">
                                                    <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => { setValues(item); setShowModal(true); }}><i className="ri-pencil-line"></i></button>
                                                    <button className="btn btn-sm btn-outline-danger border-0" onClick={() => { setItemToDelete(item.serviceTypeId); setShowDeleteModal(true); }}><i className="ri-delete-bin-line"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* MOBILE CARDS */}
                        <div className="d-md-none p-3">
                            {lists.map((item) => (
                                <div key={item.serviceTypeId} className="card border rounded-3 mb-3 shadow-sm">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div>
                                                <h6 className="fw-bold mb-0 text-dark">{item.name}</h6>
                                                <small className="text-muted">{item.category || 'Uncategorized'}</small>
                                            </div>
                                            <h6 className="fw-bold text-success mb-0">{formatCurrency(parseFloat(item.price))}</h6>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <span className="small text-muted"><i className="ri-time-line me-1"></i>{item.durationMinutes} mins</span>
                                            <span className={`badge rounded-pill ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                                {item.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                        <div className="d-flex gap-2 pt-2 border-top">
                                            <Button variant="outline-primary" size="sm" className="flex-grow-1" onClick={() => { setValues(item); setShowModal(true); }}>
                                                <i className="ri-pencil-line me-1"></i> Edit
                                            </Button>
                                            <Button variant="outline-danger" size="sm" onClick={() => { setItemToDelete(item.serviceTypeId); setShowDeleteModal(true); }}>
                                                <i className="ri-delete-bin-line"></i>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* SERVICE FORM MODAL */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">{values.serviceTypeId === "00000000-0000-0000-0000-000000000000" ? 'Add New Service' : 'Edit Service'}</Modal.Title></Modal.Header>
                    <Modal.Body className="px-4 py-3">
                        <form className="row g-3" onSubmit={handleSubmit}>
                            <div className="col-12"><label className="form-label small fw-bold">Service Name *</label><input type="text" name="name" value={values.name} onChange={handleInput} className="form-control" required placeholder="Enter service name"/></div>
                            <div className="col-md-6"><label className="form-label small fw-bold">Category *</label><select name="category" value={values.category} onChange={handleInput} className="form-select" required><option value="">-- Choose Category --</option>{categories.map(c => (<option key={c.categoryId || c.value} value={c.name || c.value}>{c.name || c.label}</option>))}</select></div>
                            <div className="col-6 col-md-3"><label className="form-label small fw-bold">Duration (Min) *</label><input type="number" name="durationMinutes" value={values.durationMinutes} onChange={handleInput} className="form-control" required/></div>
                            <div className="col-6 col-md-3"><label className="form-label small fw-bold">Price *</label><input type="number" step="0.01" name="price" value={values.price} onChange={handleInput} className="form-control" required/></div>
                            <div className="col-12"><div className="form-check form-switch mt-2"><input className="form-check-input" type="checkbox" name="isActive" checked={values.isActive} onChange={handleInput} id="isActiveSwitch"/><label className="form-check-label fw-bold text-dark" htmlFor="isActiveSwitch">Active Service</label></div></div>
                            <div className="modal-footer border-0 p-0 mt-4"><Button variant="light" onClick={() => setShowModal(false)} className="px-4">Cancel</Button><Button type="submit" disabled={btnLoading} style={{ backgroundColor: THEME_COLOR }} className="text-white px-4 border-0 shadow-sm">{btnLoading ? <Spinner size="sm" /> : 'Save Service'}</Button></div>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* DELETE MODAL */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton><Modal.Title className="text-danger fw-bold">Remove Service</Modal.Title></Modal.Header>
                    <Modal.Body>Are you sure you want to delete this service?</Modal.Body>
                    <Modal.Footer className="border-0"><Button variant="light" onClick={() => setShowDeleteModal(false)}>Cancel</Button><Button variant="danger" onClick={handleDelete}>Delete Permanently</Button></Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default SalonService;